<template>
  <div>
    <TitlePage :title="$t('dashboard')"></TitlePage>
    <v-container fluid>
      <div class="dashboard-page">
        <v-row>
          <v-col cols="12">
            <v-chip color="primary" label small text-color="white">Numeri</v-chip>
          </v-col>
          <template v-for="(number,key) in numbers">
            <v-col lg="3" sm="6" md="3" cols="12">
              <v-card class="mx-auto" outlined elevation="2">
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="text-overline mb-1">
                      {{ $t(key) }}
                    </div>
                    <v-list-item-title class="text-h3 mb-3 mt-0">
                      {{ number }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{(key == 'bookings') ? 'TOTALI':'ATTIVI'}}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-avatar tile size="80" color="green">
                    <v-icon large color="white">{{getIcon(key)}}</v-icon>
                  </v-list-item-avatar>
                </v-list-item>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn color="primary" dark x-small @click="goToHandler(key)">
                    GESTISCI {{ $t(key) }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </template>
        </v-row>
        <v-divider class="ma-5"></v-divider>
        <v-row>
          <v-col md="10" xs="12">
            <v-chip color="primary" label small text-color="white">Riepilogo per Date</v-chip>
          </v-col>
          <v-col cols="12" md="3">
            <CenterSelectSearch
                v-model="filter.center_id"
                :multiple="false"
                :includeAllOption="true"
                autoStrategy="user"
                :returnObject="false"
                @message="setCenterId"
            />
            <v-text-field
                v-model="dateRangeText"
                label="Range di Date per la Ricerca"
                readonly
                outlined
                dense
                clearable
                class="mt-2"
            ></v-text-field>
            <v-date-picker
                v-model="period"
                range
                first-day-of-week="1"
                no-title
                style="width: 100%"
            ></v-date-picker>
<!--            <v-btn elevation="2" color="error" small class="mr-2" @click="reset()">-->
<!--              RESET-->
<!--            </v-btn>-->
<!--            <v-btn elevation="2" color="primary" small class="mr-2" @click="makeSearch()">-->
<!--              <v-icon left>mdi-card-search</v-icon>-->
<!--              {{ $t('search') }}-->
<!--            </v-btn>-->
          </v-col>
          <v-col cols="12" md="9">
            <small>* Valori potenziali</small>
            <v-card elevation="2">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Status</th>
                    <th>N° Prenotazioni</th>
                    <th>Online / Manuali</th>
                    <th>Guadagno uCamp</th>
                    <th>Guadagno Centro</th>
                    <th>Rimborsi</th>
                    <th>Promo SuperAdmin</th>
                    <th>Promo Gestore</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="item in stats">
                    <tr>
                      <td><v-chip small :color="getStatus(item.status, 'color')">{{ getStatus(item.status, 'name') }}</v-chip></td>
                      <td :title="item.num">{{(item.num > 1000) ? (item.num/1000).toFixed(2)+' K': item.num}}</td>
                      <td :title="item.num_online+'/'+item.num_manual">{{(item.num_online > 1000) ? (item.num_online/1000).toFixed(2)+' K': item.num_online}} / {{(item.num_manual > 1000) ? (item.num_manual/1000).toFixed(2)+' K': item.num_manual}}</td>
                      <td>
                        <v-chip :outlined="checkPotentialValue(item.status)" color="primary" small :title="item.totals_online.toFixed(2)">
                          <span v-if="checkPotentialValue(item.status)">*</span> {{ (item.totals_online > 1000) ? (item.totals_online/1000).toFixed(2)+' K': item.totals_online.toFixed(2) }} €
                        </v-chip>
                      </td>
                      <td>
                        <v-chip :outlined="checkPotentialValue(item.status)" color="success" small :title="item.totals_center.toFixed(2)">
                          <span v-if="checkPotentialValue(item.status)">*</span> {{ (item.totals_center > 1000) ? (item.totals_center/1000).toFixed(2)+' K': item.totals_center.toFixed(2) }} €
                        </v-chip>
                      </td>
                      <td>
                        <v-chip :outlined="checkPotentialValue(item.status)" color="warning" small :title="item.refund.toFixed(2)">
                          <span v-if="checkPotentialValue(item.status)">*</span> {{ (item.refund > 1000) ? (item.refund/1000).toFixed(2)+' K': item.refund.toFixed(2) }} €
                        </v-chip>
                      </td>
                      <td>
                        <v-chip color="error" small>{{ item.promo_sa }}</v-chip>
                      </td>
                      <td>
                        <v-chip color="info" small>{{ item.promo }}</v-chip>
                      </td>
                    </tr>
                  </template>

                  <tr>
                    <td><v-chip small label outlined>TOTALI</v-chip></td>
                    <td :title="bookings_stats.bookings_total">{{(bookings_stats.bookings_total > 1000) ? (bookings_stats.bookings_total/1000).toFixed(2)+' K': bookings_stats.bookings_total}}</td>
                    <td :title="bookings_stats.bookings_online+'/'+bookings_stats.bookings_manual">{{(bookings_stats.bookings_online > 1000) ? (bookings_stats.bookings_online/1000).toFixed(2)+' K': bookings_stats.bookings_online}} / {{(bookings_stats.bookings_manual > 1000) ? (bookings_stats.bookings_manual/1000).toFixed(2)+' K': bookings_stats.bookings_manual}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>

                  <!--                  <tr>-->
                  <!--                    <td></td>-->
                  <!--                    <td><strong>Totali</strong></td>-->
                  <!--                    <td>-->
                  <!--                      <v-chip small>{{ totals_to_show.bookings_total }}</v-chip>-->
                  <!--                    </td>-->
                  <!--                    <td>-->
                  <!--                      <v-chip small>{{ totals_to_show.bookings_confirmed }}</v-chip>-->
                  <!--                    </td>-->
                  <!--                    <td>-->
                  <!--                      <v-chip small>{{ totals_to_show.bookings_to_be_confirmed }}</v-chip>-->
                  <!--                    </td>-->
                  <!--                    <td>-->
                  <!--                      <v-chip small>{{ totals_to_show.bookings_cancelled }}</v-chip>-->
                  <!--                    </td>-->
                  <!--                    <td>-->
                  <!--                      <v-chip small>{{ totals_to_show.amount.toFixed(2) }} €</v-chip>-->
                  <!--                    </td>-->
                  <!--                  </tr>-->
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
        <v-divider class="ma-5"></v-divider>
        <v-row>

          <v-col cols="12" md="6">
            <v-card class="mx-1 mb-1 mt-3" elevation="2">
              <v-card-title class="flex-nowrap pa-6 pb-3">
                <p class="text-truncate">Online / Manuali</p>
              </v-card-title>
              <v-card-text class="pa-4 pt-0 d-flex justify-center">
                <ApexChart
                    type="donut"
                    :options="bookings_type.options"
                    :series="bookings_type.series"
                    height="260"
                    width="260"
                />
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card class="mx-1 mb-1 mt-3" elevation="2">
              <v-card-title class="flex-nowrap pa-6 pb-3">
                <p class="text-truncate">Statistiche Cancellazioni Totali</p>
              </v-card-title>
              <v-card-text class="pa-4 pt-0 d-flex justify-center">
                <ApexChart
                    v-if="chartSeriesCancellation.length > 0 && chartOptionsCancellation.labels.length > 0"
                    type="donut"
                    :options="chartOptionsCancellation"
                    :series="chartSeriesCancellation"
                    height="260"
                    width="260"
                />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <ReservationBySlotAndWeekday :filters="{
                booking_type: 'all',sport_id: [],center_id: [this.filter.center_id], from: new Date(this.period[0]).getTime(), to: new Date(this.period[1]).getTime(), user_id: null, lat: null, lng: null,radius_km: 2}
              "/>
          </v-col>
        </v-row>
        <v-divider class="ma-5"></v-divider>
      </div>
    </v-container>
  </div>
</template>

<script>
import TitlePage from "../utils/TitlePage";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";
import {mapActions, mapMutations} from "vuex";
import ApexChart from "vue-apexcharts";
import ReservationBySlotAndWeekday from "@/components/analytics/ReservationBySlotAndWeekday.vue";
import CenterSelectSearch from "@/components/filters/CenterSelectSearch.vue";

export default {
  name: "DashboardSuperAdmin",
  components: {CenterSelectSearch, ReservationBySlotAndWeekday, TitlePage,CenterAutocomplete,ApexChart},
  data() {
    return {

      numbers: [],
      stats: [],
      bookings_stats: {},

      pathCenters: '/centers/',
      pathFields: '/fields/',
      pathBookings: '/bookings/',
      pathCustomers: '/customers/',

      period:[],
      filter:{},

      renderComponent: true,

      bookings_manual_percent: 0,
      bookings_online_percent: 0,
      bookings_type: {
        options: {
          colors: ['#4CAF50', '#FF5252'],
          labels: ["Manuali", "Online"],
          legend: {
            position: 'bottom'
          }
        },
        series: [],
      },

      chartOptionsCancellation: {
        labels: [],
        legend: {
          position: 'bottom'
        },
        tooltip: {
          y: {
            formatter: val => `${val} cancellazioni`
          }
        }
      },
      chartSeriesCancellation: [],
      totalCancellations: 0

    };
  },
  watch:{
    period(){
      this.makeSearch()
    },
    'filter.center_id': function(){ this.makeSearch(); },

  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getDashboardSuperAdminInfo': 'stats/getDashboardSuperAdminInfo',
    }),

    checkPotentialValue(status){
      return status != 'completed' && status != 'to_be_confirmed' && status != 'booked';
    },

    goToHandler(section) {
      switch (section) {
        case "centers":
          this.$router.push('/centers/');
          break
        case "fields":
          this.$router.push('/fields/');
          break
        case "bookings":
          this.$router.push('/bookings/');
          break
        case "customers":
          this.$router.push('/customers/');
          break
      }
    },

    getIcon(key) {
      switch (key) {
        case "centers":
          return 'mdi-stadium-variant'
        case "fields":
          return 'mdi-soccer-field'
        case "bookings":
          return 'mdi-calendar'
        case "customers":
          return 'mdi-account-convert'
      }
    },

    getStatus(status, type) {
      switch (status) {
        case "completed":
          return (type == 'name') ? 'Completata' : 'success'
        case "booked":
          return (type == 'name') ? 'Prenotato' : 'primary'
        case "to_be_payed":
          return (type == 'name') ? 'Da Pagare' : 'info'
        case "canceled":
        case "refunded":
          return (type == 'name') ? 'Annullata' : 'error'
        case "interrupted":
          return (type == 'name') ? 'Interrotta' : 'secondary'
        case "pending":
          return (type == 'name') ? 'In attesa' : 'info'
        case "to_be_confirmed":
          return (type == 'name') ? 'Da confermare' : 'warning'
        default:
          return (type == 'name') ? status : 'info'
      }
    },


    formatDate(date) {
      return date.getFullYear()+'-'+('0' + (date.getMonth()+1)).slice(-2)+'-'+('0' + date.getDate()).slice(-2)
    },

    formatDateHuman(my_date) {
      if(my_date){
        var date = new Date(my_date)
        return ('0' + date.getDate()).slice(-2)+'-'+('0' + (date.getMonth()+1)).slice(-2)+'-'+date.getFullYear()
      }else {
        return ''
      }

    },
    async setCenterId(id) {
      this.filter.center_id = id
    },

    async makeSearch(){
      this.setLoading(true);

      var start = new Date(this.period[0])
      var end = new Date(this.period[1])

      if(!this.period[0] || !this.period[1]){
        this.setLoading(false);
        return false
      }

      if(end < start){
        alert('Errore: Data di Fine antecedente alla data di Inizio')
        this.setLoading(false);
        return false
      }

      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if(diffDays > 60){
        alert('Errore: Selezionare un\'intervallo inferiore a 60 giorni')
        this.setLoading(false);
        return false
      }

      this.filter.period = this.period
      let results = await this.getDashboardSuperAdminInfo(this.filter);

      this.numbers = results.numbers
      this.stats = results.stats
      this.bookings_stats = results.bookings_stats

      let cancellation_stats = results.cancellation_stats
      if(cancellation_stats){
        this.chartOptionsCancellation.labels = cancellation_stats.map(d => d.reason);
        this.chartSeriesCancellation = cancellation_stats.map(d => d.count);
        this.totalCancellations = this.chartSeriesCancellation.reduce((a, b) => a + b, 0);
      }

      if (this.bookings_stats.bookings_total === 0) {
        this.bookings_manual_percent = 0;
        this.bookings_online_percent = 0;
        this.bookings_type.series = [0, 0];
      } else {
        this.bookings_manual_percent = (this.bookings_stats.bookings_manual * 100) / this.bookings_stats.bookings_total;
        this.bookings_online_percent = (this.bookings_stats.bookings_online * 100) / this.bookings_stats.bookings_total;
        this.bookings_type.series = [
          this.bookings_stats.bookings_manual,
          this.bookings_stats.bookings_online
        ];
      }
      this.setLoading(false);
    },
    async reset(){
      this.setLoading(true);
      const now = new Date();
      const prior = new Date().setDate(now.getDate() - 30);
      var start = new Date(prior)

      this.filter = {}
      this.period = []
      this.period.push(this.formatDate(start, 'yyyy/mm/dd'))
      this.period.push(this.formatDate(now, 'yyyy/mm/dd'))

      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });

      await this.makeSearch()
      this.setLoading(false);
    },

    getPercent(index) {
      if (!this.totalCancellations) return 0;
      return ((this.chartSeriesCancellation[index] / this.totalCancellations) * 100).toFixed(1);
    }
  },
  mounted() {

  },
  computed: {
    dateRangeText () {
      return this.formatDateHuman(this.period[0])+' ~ '+this.formatDateHuman(this.period[1])
    },
  },
  async created() {
    this.setLoading(true);
    const now = new Date();
    const prior = new Date().setDate(now.getDate() - 7);
    var start = new Date(prior)

    this.period = []
    this.period.push(this.formatDate(start, 'yyyy/mm/dd'))
    this.period.push(this.formatDate(now, 'yyyy/mm/dd'))

    await this.makeSearch()
    this.setLoading(false);
  },


}
</script>

<style>

</style>